/**
 * The key used for storing and emitting the app proxy configuration.
 *
 * This constant serves two purposes:
 * - It is the name of the custom event emitted to pass app proxy configuration to the web pixel.
 * - It is also the name of the cookie where the app proxy configuration information is stored.
 */
export const COVEO_SHOPIFY_CONFIG_KEY = 'coveo_shopify_config';
